import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { Helmet } from 'react-helmet-async';
import styled, { createGlobalStyle } from 'styled-components';
import SwipeInstruction from '@ow/ow-components/lib/components/SwipeInstruction';
import theme from '@ow/ow-components/lib/theme';

const CarouselContainer = styled.div`
  position: relative;
`;

const SlideWrapper = styled.div`
  // react-slick wants to inline-block this wrapper so we have to keep it !important
  display: block !important;
`;

const CarouselStyle = createGlobalStyle`
  .slick-active {
    z-index: ${theme.zIndex.overlays};
  }
`;

const settings = {
  dots: false,
  infinite: true,
  autoplay: true,
  fade: true,
  adaptiveHeight: true,
  autoplaySpeed: 5000,
  arrows: false,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1
};

class FadeCarousel extends Component {
  state = { removeInstruction: false };

  shouldComponentUpdate(nextProps, nextState) {
    // We don't allow to update component via props to not break the Adobe Target (A/B testing)
    return this.state.removeInstruction !== nextState.removeInstruction;
  }

  componentDidMount() {
    this.setState({ removeInstruction: true });
  }

  next = () => {
    this.slider.slickNext();
  };

  previous = () => {
    this.slider.slickPrev();
  };

  render() {
    const { children, renderLeftButton, renderRightButton, className } = this.props;
    const { removeInstruction } = this.state;
    const slides = Children.toArray(children).map(slide => (
      <SlideWrapper key={slide.key}>{slide}</SlideWrapper>
    ));

    return (
      <CarouselContainer className={className}>
        <CarouselStyle />
        <Helmet>
          <link
            rel="stylesheet"
            type="text/css"
            // eslint-disable-next-line react/no-unknown-property
            charSet="UTF-8"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
          />
        </Helmet>
        <Slider ref={c => (this.slider = c)} {...settings}>
          {slides}
        </Slider>
        {renderLeftButton({ onClick: this.previous })}
        {renderRightButton({ onClick: this.next })}
        <SwipeInstruction removeInstruction={removeInstruction} />
      </CarouselContainer>
    );
  }
}

FadeCarousel.PropTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  renderLeftButton: PropTypes.func,
  renderRightButton: PropTypes.func,
  className: PropTypes.string
};

export default FadeCarousel;
